<template>
	<vxe-modal v-model="modal" :title="title" width="1000" height="800" @show="show" show-footer destroy-on-close>
		<template #default>
			<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" height="auto" :ref="gridRef"></vxe-grid>
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			title: {
				default: () => {
					return '明细'
				}
			}
		},
		data() {
			return {
				gridRef: Math.random(),
				sourcedata: [],
				modal: false,
				loading: false,
				list_formConfig: [],
				list_footerField: [{
					field: 'amount',
					fixed: 2
				}],
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						type: 'seq',
						title: '#',
						width: 80,
					}, {
						field: 'mainOrderId',
						title: '线上单号',
					},
					{
						field: 'salercpt_no',
						title: '系统单号'
					},
					{
						field: 'storage_name',
						title: '仓库',
					},
					{
						field: 'delivery_name',
						title: '快递',
					},
					{
						field: 'amount',
						title: '赔款金额',
						sortable: true,
					},
					{
						field: 'errordetail',
						title: '判断依据',
						width: 200,
						sortable: true,
					}
				]
			},
			list() {
				return new Promise((resolve) => {
					resolve({
						list: this.data
					})
				})

			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {

			},
			modalShow() {
				this.modal = true
			},
		},
		components: {

		}
	}
</script>